/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ships_WorldwideInputs */

const en_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ships Worldwide`)
};

const es_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envíos a todo el mundo`)
};

const fr_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expédié dans le monde entier`)
};

const de_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand weltweit`)
};

const ja_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`世界中に発送可能`)
};

const zh_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球发货`)
};

const ar_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يشحن لجميع أنحاء العالم`)
};

const id_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman Seluruh Dunia`)
};

const it_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spedisce in Tutto il Mondo`)
};

const ru_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка по всему миру`)
};

const pt_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envio para todo o mundo`)
};

const ko_ships_worldwide = /** @type {(inputs: Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전 세계 배송`)
};

/**
* | output |
* | --- |
* | "Ships Worldwide" |
*
* @param {Ships_WorldwideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ships_worldwide = /** @type {((inputs?: Ships_WorldwideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ships_WorldwideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ships_worldwide(inputs)
	if (locale === "es") return es_ships_worldwide(inputs)
	if (locale === "fr") return fr_ships_worldwide(inputs)
	if (locale === "de") return de_ships_worldwide(inputs)
	if (locale === "ja") return ja_ships_worldwide(inputs)
	if (locale === "zh") return zh_ships_worldwide(inputs)
	if (locale === "ar") return ar_ships_worldwide(inputs)
	if (locale === "id") return id_ships_worldwide(inputs)
	if (locale === "it") return it_ships_worldwide(inputs)
	if (locale === "ru") return ru_ships_worldwide(inputs)
	if (locale === "pt") return pt_ships_worldwide(inputs)
	return ko_ships_worldwide(inputs)
});